import React, { useEffect, useState } from "react";
import Button from "../../Components/Button";
import Label from "../../Components/Label";
import Round from "../../Components/Round";
import TextInput from "../../Components/TextInput";
import Formatter from "../../Utils/Formatter";

let total = 0;

const Symboles = {
    DJ: {
        LotByBalance: 350,
        PointValuue: 10,
    },
    XAU: {
        LotByBalance: 550,
        PointValuue: 100,
    },
};
const expSaved = JSON.parse(localStorage.getItem("expSaved")) || { lot: 0.1, profitToLose: 4, factors: 2, steps: 10, points: 1, symbole: "DJ" };
let init = false;
const CalclateLotCard = ({ setData }) => {
    const [lot, setLot] = useState(expSaved.lot);
    const [factors, setFactors] = useState(expSaved.factors);
    const [steps, setSteps] = useState(expSaved.steps);
    const [points, setPoints] = useState(expSaved.points);
    const [symbole, setSymbole] = useState(expSaved.symbole);

    const calclate = () => {
        let _lot = Round(lot);
        let _points = Round(points * selectedSymbole.PointValuue);
        total = 0;
        let profits = [{ lot: "-", profit: "-", total: Round(_points * _lot), balanceRequired: "-", traies: "-" }];
        for (let index = 0; index < steps; index++) {
            profits.push(getResult(_lot, _points));
            _lot = Round(_lot * factors);
        }
        setData({ keys: Object.keys(profits[0]), items: profits });
    };
    const selectedSymbole = React.useMemo(() => {
        let _prevLot = lot;
        const _symbole = Symboles[symbole];
        while (_prevLot < 1) _prevLot *= 10;
        setLot((1 / _symbole.PointValuue) * _prevLot);
        return _symbole;
    }, [symbole]);

    const getResult = (_lot, _points) => {
        const profit = Round(_lot * _points * factors);
        const balanceRequired = Round(_lot * selectedSymbole.LotByBalance - total);
        total = Round(total + profit);
        return {
            lot: Formatter(_lot),
            profit: Formatter(profit),
            total: Formatter(total),
            balanceRequired: Formatter(balanceRequired),
            traies: Round(total / (_points * lot)),
        };
    };

    useEffect(() => {
        calclate();
        if (!init) init = true;
        else localStorage.setItem("expSaved", JSON.stringify({ lot, factors, steps, points, symbole }));
    }, [lot, factors, steps, points]);

    return (
        <div style={{ direction: "ltr" }} className="flex flex-col gap-3 background py-5 rounded-md">
            <p className="text-center carbonic-card-1 rounded-2xl self-center p-1">
                {Object.keys(Symboles).map((key, i) => (
                    <span
                        key={i}
                        className={`mx-2 select-none cursor-pointer px-4 rounded-xl text-white ${symbole === key ? "red-card" : "carbonic-card-1"}`}
                        onClick={() => setSymbole(key)}>
                        {key}
                    </span>
                ))}
            </p>
            <TextInput value={lot} setValue={setLot} Key="Lot" type="number" step={1 / selectedSymbole.PointValuue} />
            <TextInput value={factors} setValue={setFactors} Key="IncresFactor" type="number" />
            <TextInput value={steps} setValue={setSteps} Key="Steps" type="number" />
            <TextInput value={points} setValue={setPoints} Key="Points" type="number" />
            {/* <Label title="Result" info={profit} />
            <Label title="BalanceRequired" info={balaceRequired} /> */}
            {/* <Button onClick={calclate} color="green" title="Calculate" /> */}
        </div>
    );
};

export default React.memo(CalclateLotCard);
